import uiKanbanColumn from './column/index.vue'
import uiKanbanCardDeals from './cards/deals/index.vue'

export { uiKanbanColumn, uiKanbanCardDeals }
